import React from 'react';

interface Props {
	size: number;
}

export const BusinessIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>business</title>
		<path d='M2.78 20.61a2.4 2.4 0 112.4-2.4 2.39 2.39 0 01-2.4 2.4zm0-3.95a1.56 1.56 0 101.56 1.55 1.55 1.55 0 00-1.56-1.55zM12 20.61a2.4 2.4 0 112.4-2.4 2.4 2.4 0 01-2.4 2.4zm0-3.95a1.56 1.56 0 101.56 1.55A1.56 1.56 0 0012 16.66zM12 10.24a3.43 3.43 0 113.42-3.43A3.43 3.43 0 0112 10.24zm0-6a2.59 2.59 0 102.58 2.58A2.59 2.59 0 0012 4.23zM21.22 20.61a2.4 2.4 0 112.39-2.4 2.4 2.4 0 01-2.39 2.4zm0-3.95a1.56 1.56 0 101.55 1.55 1.56 1.56 0 00-1.55-1.55z' />
		<path d='M11.58 9.4h.84v7.08h-.84z' />
		<path d='M21.85 16.66h-.84v-2.63H3.42v2.63h-.84v-3.47h19.27v3.47z' />
	</svg>
);
